let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("g3NNd")).then(() => parcelRequire('2iXPf'));